function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var localStorageLM = {
  init: function init() {
    var LMDataKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'LMData';
    if (!storageKeyExist('LMData')) {
      localStorageLM.preset(LMDataKey);
    } else {
      var LMData = getDataObject(LMDataKey);
      clean(LMData);
    }
  },
  preset: function preset() {
    var LMDataKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'LMData';
    if (!window['localStorage'].getItem(LMDataKey)) {
      window.localStorage[LMDataKey] = JSON.stringify({});
    }
    if (!window['sessionStorage'].getItem(LMDataKey)) {
      window.sessionStorage[LMDataKey] = JSON.stringify({});
    }
  },
  get: function get(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localStorage';
    var LMDataKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LMData';
    var LMDataValue = getDataObject(LMDataKey);
    if (LMDataValue[type] && LMDataValue[type][key]) {
      return LMDataValue[type][key].data;
    }
    if (window.DEBUG) {
      console.warn("Key \"".concat(key, "\" don't exist in \"").concat(type, "\""));
    }
    return '';
  },
  set: function set(key, value) {
    var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'localStorage';
    var LMDataKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'LMData';
    // Set or update data by key, define or update expire date
    // expire date (object) or day number (number)
    if (_typeof(value) !== 'object' && typeof value !== 'string') {
      console.error("L'objet \"".concat(key, "\" pass\xE9 en param\xE8tre est invalide"));
      return false;
    }
    var LMDataValue = getDataObject(LMDataKey);
    LMDataValue[type][key] = {
      'expire': expireIn(expire),
      'data': value
    };
    writeInStorage(type, LMDataValue, LMDataKey);
    return LMDataValue[type][key];
  },
  "delete": function _delete(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localStorage';
    var LMDataKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LMData';
    var LMDataValue = getDataObject(LMDataKey);
    if (LMDataValue[type][key]) {
      delete LMDataValue[type][key];
      writeInStorage(type, LMDataValue, LMDataKey);
    }
    return LMDataValue;
  },
  exist: function exist(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localStorage';
    var LMDataKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LMData';
    var LMDataValue = getDataObject(LMDataKey);
    if (LMDataValue[type]) {
      return typeof LMDataValue[type][key] !== 'undefined';
    }
    return false;
  },
  getExpireDate: function getExpireDate(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localStorage';
    var LMDataKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LMData';
    var LMDataValue = getDataObject(LMDataKey);
    if (LMDataValue[type] && LMDataValue[type][key]) {
      return LMDataValue[type][key].expire;
    }
  }
};
var now = new Date().getTime();
var expireIn = function expireIn(days) {
  // get a day number, return a timestamp
  var then = now + days * 24 * 60 * 60 * 1000;
  return then;
};
var writeInStorage = function writeInStorage(type, LMData) {
  var LMDataKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LMData';
  window[type].setItem(LMDataKey, JSON.stringify(LMData[type]));
};
var getDataObject = function getDataObject() {
  var LMDataKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'LMData';
  var LMDataValue = {};
  LMDataValue.localStorage = JSON.parse(window['localStorage'].getItem(LMDataKey)) || {};
  LMDataValue.sessionStorage = JSON.parse(window['sessionStorage'].getItem(LMDataKey)) || {};
  return LMDataValue;
};
var storageKeyExist = function storageKeyExist() {
  var LMDataKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'LMData';
  if (!window['localStorage'].getItem(LMDataKey) && !window['sessionStorage'].getItem(LMDataKey)) {
    return false;
  } else {
    return true;
  }
};
var clean = function clean(LMDataKey) {
  // Loop true data and delete expired data
  Object.keys(LMDataKey).forEach(function (dataPlace) {
    Object.keys(LMDataKey[dataPlace]).forEach(function (item) {
      if (now > LMDataKey[dataPlace][item].expire) {
        localStorageLM["delete"](item, dataPlace);
      }
    });
  });
};
localStorageLM.init();